export function Footer() {
    return (
        <div className="flex flex-col items-center mt-20 py-8 px-12 bg-white">
            <div className="flex justify-center border-b-[1px] border-neutral-900 py-4 w-full">
                <h2 className="text-3xl font-semibold text-dark">kcb</h2>
            </div>
            <div className="py-4">
                <span className="text-sm font-light text-dark">Contact: 1016131@hr.nl - 0960572@hr.nl</span>
            </div>
            <div className="py-4">
                <span className="text-sm font-light text-dark">2024 NPO | Alle rechten voorbehouden</span>
            </div>
        </div>
    );
}